import React, { Component } from 'react';
import { getFieldsType } from '../Taula/TaulaUtils';
import { StatsWrapper } from './StatsElement';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';
import CustomDropdown from '../../../../../Cerca/CercaAvançada/CustomDropdown';
import { PopUpCloseBtn, PopUpHeader, PopUpTitle, SeparatorLine } from '../../CapaLlegendaFooterElements';
import { toast } from 'react-toastify';
import { Oval } from 'react-loader-spinner';

export default class StatsSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: [getTranslatedKey('selectAttr')],
      loading: false,
      reset: true
    };
  }

  componentDidMount = async () => {
    this.setState({ loading: true });
    let typesObj = await getFieldsType(this.props.layer);
    this.setState({ loading: false });

    let numericFields = [getTranslatedKey('selectAttr')];
    if (typesObj) {
      for (const key in typesObj) {
        if (typesObj[key] === 'number') {
          let properties = this.props.layer.getProperties();
          let property = properties.find((property) => property.name === key);
          numericFields.push(property?.alias || key);
        }
      }
    }
    this.setState({ fields: numericFields }, () => {
      if (this.state.fields.length === 1) {
        this.props.openStatistic();
        toast.info(getTranslatedKey('theLayer') + ' ' + this.props.layer.getTitle() + ' ' + getTranslatedKey('noNumAtr'));
      }
    });
  };

  setSelected = async (option) => {
    this.setState({ selected: option });
    this.props.selectField(option);
    this.props.statsLayerSelect(this.props.layer, option);
  };

  render() {
    return (
      <>
        <SeparatorLine />
        <PopUpHeader>
          <PopUpTitle fontSizeEnabled={this.props.fontSizeEnabled}>{getTranslatedKey('layerStats')}</PopUpTitle>
          <PopUpCloseBtn title={getTranslatedKey('tancar')} onClick={() => this.props.openStatistic()}>
            <svg
              width={this.props.fontSizeEnabled ? 24 * 1.3 : 24}
              fill="white"
              transform="rotate(180)"
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              data-testid="ExpandMoreIcon">
              <path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path>
            </svg>
          </PopUpCloseBtn>
        </PopUpHeader>

        {this.state.loading ? (
          <Oval
            height={window.innerHeight > 400 ? 80 : 40}
            width={window.innerHeight > 400 ? 80 : 40}
            color="#febf00"
            wrapperStyle={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
            wrapperClass=""
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#ccc"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        ) : (
          <StatsWrapper>
            <CustomDropdown
              setSelected={this.setSelected}
              options={this.state.fields}
              margin={false}
              displayFilter={false}
              reset={this.state.reset}
              fixed={true}
            />
          </StatsWrapper>
        )}
      </>
    );
  }
}
